import React from "react"
import { TextInput, InputNumber, Select } from "components-design-system"

export default function DynamicField({ type, fieldProps }) {
  if (type === "text")
    return (
      <TextInput
        {...fieldProps}
        onChange={(e) => fieldProps.onChange(e.target.value)}
      />
    )
  else if (type === "textarea")
    return (
      <TextInput
        type="textarea"
        {...fieldProps}
        onChange={(e) => fieldProps.onChange(e.target.value)}
      />
    )
  else if (type === "number") return <InputNumber {...fieldProps} />
  else if (type === "dropdown") return <Select {...fieldProps} />
  else if (type === "multiselect")
    return (
      <Select
        {...fieldProps}
        mode="multiple"
      />
    )
  else if (type === "tags")
    return (
      <Select
        {...fieldProps}
        mode="tags"
      />
    )
  return null
}
